import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { getClientDomain, getConfig, toTitleCase } from './functions.service';
import { NotificationHelper } from './helpers/notification.helper';
import { MenuService } from './menu.service';
import { RequestsService } from './requests.service';


@Injectable({
  providedIn: 'root',
})
export class HelpersService {

  constructor(
    private _title: Title,
    private _meta: Meta,
    public notifications: NotificationHelper,
    private requestService: RequestsService,
    private menuService: MenuService,
  ) {
  }

  /**
   * Set a new page meta title
   * @param title The new title
   * @param stringCase Case to transform
   */
  public setTitle(title: string = "") {
    title = title.trim();
    if (title.length > 0) {
      this._title.setTitle(toTitleCase(`${title} | ${getConfig("app_title")}`))
    } else {
      this._title.setTitle(toTitleCase(`${getConfig("app_title")}`))
    }
    //Ponemos el titulo en el navbar de inmediato
    const navbarTitle = document.getElementById("coky-navbar-title")
    navbarTitle ? navbarTitle.innerHTML = title : ""
    //Y lo volvemos a poner por si no se habia cargado el componente
    setTimeout(() => {
      const navbarTitle = document.getElementById("coky-navbar-title")
      navbarTitle ? navbarTitle.innerHTML = title : ""
    }, 500);
  }

  /**
   * Current title
   * @returns current title
   */
  public getTitle(): string {
    return this._title.getTitle()
  }

  /**
   * Set a meta tag element on the head of current HTML
   * @param name 
   * @param content 
   * @param stringCase 
   */
  public setMetaTag(name: string = "", content: string = "") {
    name = name.trim();
    content = content.trim();
    if (name.length > 0 && content.length > 0) {
      const current = this._meta.getTag(`name='${name}'`)
      if (current) {
        current.setAttribute("content", content)
      } else {
        this._meta.addTag({ name, content })
      }
    }
  }

  public async getIcons() {
    const result = (await this.requestService.get(getClientDomain() + "/assets/properties/mat-icons.json")).data as string[]
    return result.sort()
  }
}


